module.exports = "../static/media/banner_short.276adb8c.png";